import { render, staticRenderFns } from "./MatchOdd.vue?vue&type=template&id=3f8a11f5&scoped=true"
import script from "./MatchOdd.vue?vue&type=script&lang=js"
export * from "./MatchOdd.vue?vue&type=script&lang=js"
import style0 from "./MatchOdd.vue?vue&type=style&index=0&id=3f8a11f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8a11f5",
  null
  
)

export default component.exports